// Import Bootstrap's JS
import * as bootstrap from 'bootstrap';

// Import AOS
import AOS from 'aos';

// Import our custom SCSS
import '../scss/style.scss';

// console.log('Hello from JavaScript!');

document.addEventListener('DOMContentLoaded', () => {
    // Initialize AOS
    AOS.init({disable: 'mobile'});

    // Header scroll effect
    const header = document.querySelector('header.sticky-top');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50 && window.innerWidth > 991) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }

    // Przycisk "Powrót na górę"
    const backToTopButton = document.getElementById('back-to-top');

    if (backToTopButton) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                backToTopButton.style.display = 'block';
            } else {
                backToTopButton.style.display = 'none';
            }
        });

        backToTopButton.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
});